import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import { BillingCharge } from "../entities/billingCharge.entity";

class BillingChargesDB extends FirestorePipe {

  public static readonly colName = 'BillingCharges'

  constructor() {
    super(BillingChargesDB.colName);
  }

  public create(data: any): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: any): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<BillingCharge[]> {
    return this._getAll<BillingCharge>(...params);
  }
  public get(id: string): Promise<BillingCharge> {
    return this._get(id);
  }
  public on(listener: (data: BillingCharge[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }
}

export default BillingChargesDB;
